import React from 'react';
import { PageLayout } from '../../components/layout/PageLayout';

export default function Subscriptions() {
  return (
    <PageLayout
      title="Subscriptions & Vault"
      subtitle="Automate recurring billing logic and secure tokenized data for frictionless repeat purchases."
      badge="REVENUE ENGINE"
      imageSrc="/products/art_subscriptions_1776905073731.png"
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mt-16">
        <div className="bg-white p-10 rounded-3xl border border-gray-100 shadow-sm">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">Customer Vault</h3>
          <p className="text-gray-600 mb-6">Safely store and reuse payment methods without ever touching raw card data. By tokenizing payment info, you reduce PCI scope to SAQ-A while enabling 1-click checkouts for returning users.</p>
          <ul className="space-y-3 text-gray-700">
            <li className="flex gap-2"><i className="ri-check-line text-blue-500"></i> Network Tokenization built-in</li>
            <li className="flex gap-2"><i className="ri-check-line text-blue-500"></i> Seamless Account Updater</li>
            <li className="flex gap-2"><i className="ri-check-line text-blue-500"></i> Cross-channel data portability</li>
          </ul>
        </div>
        
        <div className="bg-white p-10 rounded-3xl border border-gray-100 shadow-sm">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">Recurring Billing</h3>
          <p className="text-gray-600 mb-6">Set up complex subscription models, prorations, and trial periods out of the box. Our engine automatically retries failed payments to maximize your recovered revenue.</p>
          <ul className="space-y-3 text-gray-700">
            <li className="flex gap-2"><i className="ri-check-line text-purple-500"></i> Smart Retry Logic</li>
            <li className="flex gap-2"><i className="ri-check-line text-purple-500"></i> Automated Dunning emails</li>
            <li className="flex gap-2"><i className="ri-check-line text-purple-500"></i> Custom billing cycles & tiers</li>
          </ul>
        </div>
      </div>
    </PageLayout>
  );
}
